<template>
  <div id="previewPreExam" :style="{'background': `url(${imgUrl}) center center no-repeat`, 'background-size': '100% 100%'}" style="width: 100%; height: 100%;" v-if="isReady">
    <div class="header">
      <p>{{ planName }}</p>
      <div class="site">
        <p class="siteNumber">
          08
        </p>
        <p class="siteTitle">座位号</p>
      </div>
    </div>
    <div class="Login">
      <h1 style="color: #FFF;">考生登录</h1>
      <div class="item">
        <el-input placeholder="请输入准考证号或身份证号" style="margin: 0 auto;"></el-input>
      </div>
      <el-button style="display: block;" round>登录</el-button>
      <p class="item">返回</p>
    </div>

      <!-- <div class="header">
        <h1></h1>
      </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isReady: false,
      imgUrl: "",
      planName: this.$route.query.planName
    }
  },

  mounted() {
    this.initData();
  },

  methods: {
    initData() {
      this.$nextTick(() => {
        this.imgUrl = this.$route.query.imgUrl;
        this.isReady = true;
      })
    }
  }
}
</script>


<style scoped lang="less">
#previewPreExam {
  width: 100%;
  height: 100%;
  padding: 48px 48px;
  box-sizing: border-box;
  // font-family: "PingFangSC-Medium, PingFang SC";
  .header {
    width: 100%;
    height: 280px;
    &>p {
      color: #FFF;
      font-size: 24px;
      float: left;
    }
    .site {
      width: 280px;
      height: 280px;
      background: rgba(255, 255, 255, .2);
      float: right;
      border-radius: 8px;
      padding-top: 36px;
      box-sizing: border-box;
      .siteNumber {
        font-size: 180px;
        text-align: center;
        color: #FFF;
        line-height: 180px;
      }
      .siteTitle {
        font-size: 16px;
        font-weight: 700;
        color: rgba(255, 255, 255, .75);
        text-align: center;
      }
    }
  }

  .Login {
    width: 100%;
    height: 300px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    .item {
      width: 100%;
      text-align: center;
      color: #FFF;
      font-size: 16px;
    }
  }

  /deep/ .el-input {
    width: 540px;
    height: 54px;
    .el-input__inner {
      width: 100%;
      height: 54px;
    }
  }

  .el-button {
    width: 540px;
    height: 54px;
    font-size: 16px;
    color: #FFF;
    background: #1EC68E;
    border: transparent;
  }
}
</style>